module.exports = __webpack_public_path__ + "img-front/register/kinesis-second.bf8fb9a6.svg";